import cn from 'classnames';
import Popover, { IPopoverProps, PopoverPlacement } from '@creditflowresearch/uilib/Popover';

import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import menuStyles from './menu.module.scss';

interface IProps {
  children?: IPopoverProps['children'],
  content: React.ReactNode,
  placement?: PopoverPlacement,
  offsetOptions?: IPopoverProps['offsetOptions'],
  popoverContentClassName?: string,
  className?: string,
  arrowClassName?: string,
  isVisible?: boolean,
  setIsVisible?: (isVisible: boolean) => void,
  triggerEvent?: 'click' | 'hover',
  usePortal?: boolean,
}

/**
 * @deprecated Use import from "@creditflowresearch/uilib/Menu" instead.
 */
const Menu: React.FC<IProps> = ({
  children,
  content,
  placement = 'bottom-end',
  offsetOptions,
  popoverContentClassName,
  className,
  arrowClassName,
  isVisible,
  setIsVisible,
  triggerEvent = 'click',
  usePortal,
}) => {
  return (
    <Popover
      content={ content }
      triggerEvent={ triggerEvent }
      wrapperClassName={ cn(menuStyles.dropdownWrapper, className) }
      placement={ placement }
      offsetOptions={ offsetOptions }
      contentClassName={ cn(spaceStyles.pn, popoverContentClassName) }
      arrowClassName={ arrowClassName }
      usePortal={ usePortal }
      renderOnlyVisible
      isVisible={ isVisible }
      setIsVisible={ setIsVisible }
    >
      { children }
    </Popover>
  );
};

export default Menu;
